<section id="section-responsive-table" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Tables Responsive</p>

    <table class="table-responsive table-md m-t-20">
      <thead>
        <tr>
          <th>Name</th>
          <th>Age</th>
          <th>Address</th>
          <th>Phone</th>
          <th>Document</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td>
            <span class="responsive-title"> Name: </span>

            {{ user.name }}
          </td>

          <td>
            <span class="responsive-title"> Age: </span>

            {{ user.age }}
          </td>

          <td>
            <span class="responsive-title"> Address: </span>

            {{ user.address }}
          </td>

          <td>
            <span class="responsive-title"> Phone: </span>

            {{ user.phone }}
          </td>

          <td>
            <span class="responsive-title"> Document: </span>

            {{ user.document }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
